<template>
  <v-card class="view">


    <v-container class="container--fluid footer">
      <v-row>
        <v-col class="col-4 clickable" @click="openSales()">
          เซลล์ <span
            v-if="order.total_external_discount>0">คอมฯนอก {{
            number_format(order.total_external_discount, 2, 2)
          }} บาท</span>
          <v-divider class="mb-4"></v-divider>
          <Avatar v-for="sale in sales" v-bind:key="sale.id" :active="true" :user="sale"></Avatar>
          <v-avatar

              v-if="!sales || sales.length===0"
              color="grey"
              size="64px"
          >
            <v-icon x-large>mdi-plus</v-icon>
          </v-avatar>


        </v-col>
        <v-col class="text-right">
          ยอดสินค้า {{ number_format(order.total_gross) }} บาท<br/>
          vat {{ number_format(order.total_vat) }} บาท<br/>
          <!--<v-btn class="primary ma-2" small tile> - vat 7%</v-btn>-->
          <!--<v-btn @click="setVatType(OrderConst.VAT_TYPE_SEPARATE)"-->
          <!--:class="{primary:order.vat_type === OrderConst.VAT_TYPE_SEPARATE}" class="vat-type ma-1" small tile> vat แยก-->
          <!--</v-btn>-->
          <!--<v-btn @click="setVatType(OrderConst.VAT_TYPE_INCLUDE)"-->
          <!--:class="{primary:order.vat_type === OrderConst.VAT_TYPE_INCLUDE}" class="vat-type ma-1" small tile> + vat 7%-->
          <!--</v-btn>-->
          <!--<v-btn @click="setVatType(OrderConst.VAT_TYPE_ZERO)"-->
          <!--:class="{primary:order.vat_type === OrderConst.VAT_TYPE_ZERO}" class="vat-type ma-1" small tile> vat 0-->
          <!--</v-btn>-->
          <!--<v-btn @click="setVatType(OrderConst.VAT_TYPE_EXCEPT)"-->
          <!--:class="{primary:order.vat_type === OrderConst.VAT_TYPE_EXCEPT}" class="vat-type ma-1" small tile> ยกเว้นภาษี-->
          <!--</v-btn>-->
        </v-col>
        <v-col class="col-3 text-right">
          <div class="headline mb-4 orange--text">
            <v-icon color="orange" large>mdi-star</v-icon>
            รวม {{ number_format(order.total_point || 0) }} แต้ม
          </div>
          <v-btn
              :disabled="any_item_from_not_match"
              :loading="is_LoadSubmitCart" class="primary" tile @click="SubmitCart()">
            แลกแต้ม
          </v-btn>

        </v-col>
      </v-row>
    </v-container>


  </v-card>

</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.view {
  /*background: #00FF00;*/
  width: 100%;
  display: block;
  bottom: 0;
}

@media (min-height: 700px) {
  .view {
    position: fixed;
    height: 150px;
  }
}

.footer {
  padding: 0 12px 12px;
}

.vat-type {
  min-width: 90px !important;
}


</style>
<script lang="ts">
import Avatar from '@/components/User/Avatar.vue'
import {Component, Prop, Vue} from 'vue-property-decorator'
import {Order, OrderConst} from '../../models/Order'

import {User, UserConst} from '../../models/User'
import Helper from '../../services/Helper.js'

@Component(
    {
      components: {Avatar}
    }
)
export default class FooterPoint extends Vue {
  @Prop(Number) readonly height: number | undefined
  @Prop() readonly order: Order
  @Prop() readonly onSubmitted: (order: Order) => void
  @Prop() readonly onClickSelectAddress: () => void

  OrderConst = OrderConst
  number_format = Helper.number_format

  is_LoadSubmitCart = false
  sales: User[] = []

  get any_item_from_not_match() {
    if (!this.order.item_from) return false
    if (this.order.item_from == OrderConst.ITEM_FROM_NONE) return false
    // console.log('any_item_from_not_match',this.order.items.filter(i => i.product?.item_from != this.order.item_from))
    return this.order.items.filter(i => i.product?.item_from != this.order.item_from).length > 0
  }

  async SubmitCart() {

    if (!this.order.shipping_address_id) {
      this.onClickSelectAddress()
      return
    }

    // Show point confirmation dialog before submitting
    this.$root.$emit('openOrderConfirmPoint', {
      order: this.order,
      onApply: (order: Order) => {
        this.onSubmitted(order)
      }
    })
  }

  mounted() {

    // let sale1 = new User()
    // sale1.department = 'PJ'
    // sale1.nickname = 'น้องบาส'
    // sale1.picture = 'https://picsum.photos/120/120?image=120'
    //
    // let sale2 = new User()
    // sale2.department = 'TT'
    // sale2.nickname = 'พี่หนิง'
    // sale2.picture = 'https://picsum.photos/120/120?image=121'
    //
    // this.sales = [sale1, sale2]

    this.refreshSale()


  }

  async setVatType(type) {

    let vat_percent = 0
    switch (type) {
      case OrderConst.VAT_TYPE_SEPARATE:
        vat_percent = 0
        break
      case OrderConst.VAT_TYPE_INCLUDE:
        vat_percent = 7
        break
      case OrderConst.VAT_TYPE_ZERO:
        vat_percent = 0
        break
      case OrderConst.VAT_TYPE_EXCEPT:
        vat_percent = 0
        break
    }

    this.$store.commit('set_cart_prop', {
      vat_type: type,
      vat_percent: vat_percent
    })

    try {
      await Object.setPrototypeOf({
        id: this.order.id,
        mode: 'fill',
        vat_type: this.order.vat_type,
        vat_percent: this.order.vat_percent
      }, Order.prototype).save()
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }

  }

  private refreshSale() {
    this.sales = []
    // console.log('order sales', this.order.sales)
    for (let index in this.order.sales) {
      let sale = this.order.sales[index]
      // console.log('sales', sale)
      if (!sale || !sale.user_code) continue
      if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
        let user = this.$store.state.users.code_map[sale.user_code]
        // user.orderUser = sale;
        this.sales.push(user)
      } else {
        let sale2 = new User()
        sale2.department = '??'
        sale2.nickname = sale.user_code
        sale2.picture = null
        // sale2.orderUser = sale;
        this.sales.push(sale2)
      }
    }
  }

  private openSales() {
    // debugger
    if (
        this.order.item_from != OrderConst.ITEM_FROM_OFM &&
        ![
          UserConst.ROLE_ADMIN,
          UserConst.ROLE_CEO,
          UserConst.ROLE_DIRECTOR,
          UserConst.ROLE_MANAGER,
          UserConst.ROLE_ACCOUNT,
          UserConst.ROLE_MARKETING
        ].includes(this.$store.state.$user.role)
    ) return

    this.$root.$emit('openSales', {
      sales: this.sales, onApply: async (sales) => {
        this.order.sales = sales

        this.refreshSale()

        try {
          await Object.setPrototypeOf({
            id: this.order.id,
            mode: 'sales',
            sales: sales
          }, Order.prototype).save()
        } catch (e) {
          this.$root.$emit('onError', {error: e})
        }

      }
    })
  }

  // VAT_TYPE_SEPARATE: 0,
  // VAT_TYPE_INCLUDE: 1,
  // VAT_TYPE_ZERO: 2,
  // VAT_TYPE_EXCEPT: 3, // ยกเว้นภาษี


}
</script>


